<template>
    <div class="card p-6">
        <TabsItem v-model="activeTab" :tabs="tabs" return-route="locataire" @input="changeTab"/>
        <router-view></router-view>
    </div>
</template>

<script>

import TabsItem from './../components/composant/TabsItem';

export default {
    components: {
        TabsItem
    },
    data() {
        return {
            activeTab: "locataireDetailsDetails",
            tabs: [
                { label: "Détails", name: "locataireDetailsDetails", icon: "book"},
            ]
        }
    },
    created() {
        this.loadRoute(this.$route.name);
    },
    methods: {
        loadRoute(currentRoute) {
            if (currentRoute === "locataireDetails") {
                this.$router.push({name: this.tabs[0].name})
            }

            this.activeTab = currentRoute
        },
        changeTab(routeName) {
            this.$router.push({ name: routeName });
        },
    },
    watch: {
        $route(current) {
            this.loadRoute(current.name)
        }
    }
};
</script>